import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { useTenantQuery } from '@/hooks/useTenantQuery';
import { WorkspaceBadge } from './WorkspaceBadge';

export function ElevatedWorkspaceHeader() {
  const { t } = useTranslation('navigation');
  const { activeTenantId } = useAuth();
  const tenantQuery = useTenantQuery(activeTenantId === null ? '' : activeTenantId);
  const tenant = tenantQuery.data;

  return (
    <>
      <div className="px-2 py-1.5 font-extrabold tracking-tight truncate text-zooindigo">
        {tenant === undefined ? t('elevatedAccess.unknownWorkspace') : tenant.name}
      </div>
      {tenant === undefined ? null : (
        <div className="mt-1.5 px-2">
          <WorkspaceBadge tenantType={tenant.type} />
        </div>
      )}
    </>
  );
}
